import {ContainerTypeInfo} from "./dto/com.rico.sb2.service.queue";

export const AppConfig = {
	CP: "",
	locale: "",

	roles: [] as string[],
	authorities: [] as string[],
	userLogin: null as string | null,
	eventDisplayMinimumLevel: 'INFO',

	ContainerTypes: [] as ContainerTypeInfo[],
	ContainerTypeNamerConfig: {
		defaultName: '',
		names: {}
	},

	showSendToStorage: false,

	detailAreaUnit: 'DECIMETERS',
	containerAreaUnit: 'DECIMETERS',

	coatingLine: false,
	trolleyLine: false,
	
	directPathsOnSchema: false,
	defaultUnloadInStart: false,
	displayTraverseAsContainerNumber: false,

	suspensionTakeDelayFactor: 0,

	logged() {
		return this.roles.length > 0
	}
}